import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { SvgIcon } from '@mui/material';

type SlideSvgProps = {
  value: number;
};

function SlideSvg({ value, ...otherProps }: SlideSvgProps) {
  const maskId = `num-digits-mark-${value}`;

  return (
    <SvgIcon {...otherProps} viewBox="0 0 24 24">
      <defs>
        <mask id={maskId}>
          <rect width="24" height="24" fill="#fff" />
          <text
            x="12"
            y="13"
            textAnchor="middle"
            fontSize={value < 1000 ? 12 : 8}
            fill="black"
            fontFamily="Roboto Mono, monospace"
            dominantBaseline="middle"
          >
            {value}
          </text>
        </mask>
      </defs>
      <circle cx="12" cy="12" r="10" fill="currentColor" mask={`url(#${maskId})`} />
    </SvgIcon>
  );
}

export default SlideSvg;
